import {Component, Input, OnInit} from '@angular/core';
import * as moment from 'moment';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {MatCheckboxChange} from '@angular/material';
import {LoadingService} from '../../../services/loading.service';
import {CommonService} from '../../../services/common.service';
import {SuperMarketRefrigeratorBudgetService} from '../../../services/super-market-refrigerator-budget.service';
import {ToastMessagesService} from '../../../services/toast-messages.service';

moment.locale('el-GR');

@Component({
  selector: 'app-add-refrigerator-first-step',
  styleUrls: ['./add-refrigerator-first-step.component.scss'],
  templateUrl: './add-refrigerator-first-step.component.html'
})
export class AddRefrigeratorFirstStepComponent implements OnInit {
  @Input() data: any;
  public accessories: any;
  public barsChecked: boolean;
  public capsChecked: boolean;
  public canShowMessage: boolean;
  public casesChecked: boolean;
  public casesCombo: any[] = [];
  public categoryDescription: string;
  public checkDescription: string;
  public formGroup: FormGroup;
  private materialName: string;
  public refrigeratorCategory: any;
  public refrigeratorKinds: any;
  public isLoading: boolean;
  public stock: any;

  constructor(private commonService: CommonService,
              private loadingService: LoadingService,
              private superMarketBudgetService: SuperMarketRefrigeratorBudgetService,
              private toastMessagesService: ToastMessagesService) {
    this.formGroup = new FormGroup({
      comments: new FormControl(''),
      has_bars: new FormControl(0, Validators.required),
      has_caps: new FormControl(0, Validators.required),
      has_cases: new FormControl(0, Validators.required),
      is_led: new FormControl(0, Validators.required),
      refrigerator_category: new FormControl('', Validators.required),
      refrigerator_material: new FormControl('', Validators.required)
    });
    this.barsChecked = false;
    this.capsChecked = false;
    this.canShowMessage = false;
    this.casesChecked = false;
    this.isLoading = false;
  }

  public async ngOnInit(): Promise<any> {
    try {
      this.loadingService.show();
      this.refrigeratorKinds = await this.commonService.getSimpleList('material');
      this.refrigeratorCategory = await this.commonService.getSimpleList('evaluation/categories');
      this.accessories = await this.commonService.getSimpleList('accessory');
    } catch (e) {

    } finally {
      this.loadingService.hide();
    }
  }

  async checkCases() {
    try {
      if (this.casesChecked) {
        const materialID = this.formGroup.getRawValue().refrigerator_material;
        this.casesCombo = await this.commonService.insertObject('accessory/material_combo', {material_id: materialID});
        this.canShowMessage = this.casesCombo.length <= 0;
      } else {
        this.casesCombo = [];
        this.canShowMessage = false;
        this.casesChecked = false;
      }
    } catch (e) {
      this.toastMessagesService.toastErrorMessage('Δε μπορέσαμε να εμφανίσουμε τους κωδικούς των θηκών.');
    }
  }

  public canShowBars(): boolean {
    if (this.refrigeratorKinds) {
      const kind = this.refrigeratorKinds.find(item => item.id === this.formGroup.get('refrigerator_material').value);
      if (kind) {
        return kind.can_show_bars === 1;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  public canShowCaps(): boolean {
    if (this.refrigeratorKinds) {
      const kind = this.refrigeratorKinds.find(item => item.id === this.formGroup.get('refrigerator_material').value);
      if (kind) {
        return kind.can_show_caps === 1;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  public canShowCases(): boolean {
    if (this.refrigeratorKinds) {
      const kind = this.refrigeratorKinds.find(item => item.id === this.formGroup.get('refrigerator_material').value);
      if (kind) {
        return kind.can_show_cases === 1;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  public changeBarsCheckBoxValue($event: MatCheckboxChange): void {
    this.barsChecked = $event.checked;
    $event.checked ? this.formGroup.get('has_bars').setValue(1) : this.formGroup.get('has_bars').setValue(0);
  }

  public changeCapsCheckBoxValue($event: MatCheckboxChange): void {
    this.capsChecked = $event.checked;
    $event.checked ? this.formGroup.get('has_caps').setValue(1) : this.formGroup.get('has_caps').setValue(0);
  }

  public changeCasesCheckBoxValue($event: MatCheckboxChange): void {
    this.casesChecked = $event.checked;
    $event.checked ? this.formGroup.get('has_cases').setValue(1) : this.formGroup.get('has_cases').setValue(0);
    this.checkCases();
  }

  public changeCheckBoxValue($event: MatCheckboxChange): void {
    $event.checked ? this.formGroup.get('is_led').setValue(1) : this.formGroup.get('is_led').setValue(0);
  }

  public isFormGroupInvalid(): boolean {
    return this.formGroup.invalid || (this.casesChecked && this.casesCombo.length === 0);
  }

  materialChanged() {
    this.casesCombo = [];
    this.barsChecked = false;
    this.canShowMessage = false;
    this.capsChecked = false;
    this.casesChecked = false;
  }

  public showAccessoriesTitle(): boolean {
    return this.formGroup.get('refrigerator_material').value !== '';
  }

  public async submit(): Promise<any> {
    let data;
    try {
      this.loadingService.show();
      const hasLightDescription = this.formGroup.get('is_led').value === 0 ? 'Mη φωτιζόμενο' : 'Φωτιζόμενο';

      data = this.formGroup.getRawValue();
      const categoryInfo = this.refrigeratorCategory.find(category => category.id === data.refrigerator_category);
      this.categoryDescription = categoryInfo.category + ' ( ' + categoryInfo.name + ' )';
      const materialInfo = this.refrigeratorKinds.find(material => material.id === data.refrigerator_material);
      this.materialName = materialInfo.name;

      const categoryIndex = this.refrigeratorCategory.findIndex((item) => {
        return item.category === this.formGroup.get('refrigerator_category').value;
      });
      if (categoryIndex !== -1) {
        const returnedCategory = this.refrigeratorCategory[categoryIndex];
        data.category_description = returnedCategory.name;
      }

      const kindIndex = this.refrigeratorKinds.findIndex((item) => {
        return item.name === this.formGroup.get('refrigerator_material').value;
      });
      if (kindIndex !== -1) {
        const returnedKind = this.refrigeratorKinds[kindIndex];
        data.refrigerator_kind_id = returnedKind.id;
      }

      const object = {
        materialID: data.refrigerator_material,
        categoryID: data.refrigerator_category,
        isLed: data.is_led,
        keyAccountID: this.data.key_account_id
      };

      this.checkDescription = object.materialID + ' - ' + materialInfo.name
        + ' - ( ' + categoryInfo.category + ' - ' + hasLightDescription + ' )';

      this.stock = await this.superMarketBudgetService.checkSMBudgetStock(object);
    } catch (e) {
      this.toastMessagesService.toastErrorMessage('Δε μπορέσαμε να εμφανίσουμε το απόθεμα.');
    } finally {
      this.loadingService.hide();
    }

    return {
      formGroup: data,
      checkDescription: this.checkDescription,
      material_name: this.materialName,
      category_description: this.categoryDescription,
      stock: this.stock};
  }

}
